import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Tooltip,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import styles from './AppSidebar.module.scss';
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DescriptionIcon from '@mui/icons-material/Description';
import ScienceIcon from "@mui/icons-material/Science";
import DockIcon from '@mui/icons-material/Dock';
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import { useKeycloak } from "@react-keycloak/web";
import { IconHttpTrace } from "@tabler/icons-react";
import SidebarCollapseButton from "../SideBarCollapseButton";
import { useStore } from "../../store";

const buttunSx = {
  color: "#000",
  position: "relative",
  py: 0.5,
  paddingX: 1,
  ".MuiListItemText-primary": {
    fontSize: 14,
    fontWeight: 500,
  },
 
  ".MuiButtonBase-root": {
    padding: 1.25,
    color: "#000",
    // backgroundColor: '#ececec',
    mr: 2,
    ".MuiSvgIcon-root": {
      fontSize: 18,
    },
  },
  "&.active": {
    color: "#cb6100",
    opacity: 1,
    borderColor: "#fff",
    backgroundColor: "#ebebeb",
    ".openSidebar &::after": {
      content: '" "',
      position: "absolute",
      width: 3,
      height: "65%",
      bgcolor: "#cb6100",
      right: 6,
      borderRadius: 4,
    },
    ".MuiButtonBase-root": {
      color: "#cb6100",
      backgroundColor: "#272727",
    },
  },
};

const AppSidebar = () => {
  const { keycloak } = useKeycloak();
  const { globalState: { sidebarCollapsed } } = useStore();
  const emailDomain = keycloak.idTokenParsed?.email?.split(`@`)?.[1];
  const isPermitted = emailDomain==='korewireless.com';
	
  const changeSideBarHandler = () => {
    // const targetId = event.currentTarget.id;
    // setActiveTab(targetId);
  };

  return (
    <Box position="relative">
      <SidebarCollapseButton />
      <aside id={styles["appSidebar"]} className={["", sidebarCollapsed ? styles['closedSidebar'] : styles['openSidebar']].join(' ')} >
        <Toolbar sx={{ pl: sidebarCollapsed ? '8px !important' : 1, borderBottom: 1, borderColor: '#cdcdcd', overflow: 'hidden', transition: 'all .5s' }} variant="dense">

        </Toolbar>

        <nav aria-label="main mailbox folders">
          <List disablePadding sx={{ overflow: "hidden" }}>
            <div
              id="health"
              aria-valuetext="health"
              onClick={changeSideBarHandler}
            >
              <ListItem disablePadding>
                <Tooltip title="Health" placement="right">
                  <ListItemButton
                    component={NavLink}
                    to={`/health`}
                    sx={buttunSx}
                  >
                    <IconButton>
                      <ScienceIcon fontSize="small" />
                    </IconButton>
                    <ListItemText primary="Health" />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
            </div>
            <div id="slo" aria-valuetext="slo" onClick={changeSideBarHandler}>
              {keycloak?.authenticated && isPermitted &&(
                <ListItem disablePadding>
                  <Tooltip title="SLO" placement="right">
                    <ListItemButton
                      sx={buttunSx}
                      component={NavLink}
                      to={`/slo`}
                    >
                      <IconButton>
                        <TrackChangesIcon fontSize="small" />
                      </IconButton>
                      <ListItemText
                        primary="SLO"
                        sx={{ whiteSpace: "nowrap" }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}
            </div>
            <div
              id="API-Metrics"
              aria-valuetext="API-Metrics"
              onClick={changeSideBarHandler}
            >
              {keycloak?.authenticated && isPermitted &&(
                <ListItem disablePadding>
                  <Tooltip title="API-Metrics" placement="right">
                    <ListItemButton
                      sx={buttunSx}
                      component={NavLink}
                      to={`/metrics`}
                    >
                      <IconButton>
                        <QueryStatsIcon fontSize="small" />
                      </IconButton>
                      <ListItemText
                        primary="API Metrics"
                        sx={{ whiteSpace: "nowrap" }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}
            </div>
            <div
              id="Traces"
              aria-valuetext="Traces"
              onClick={changeSideBarHandler}
            >
              {keycloak?.authenticated && isPermitted &&(
                <ListItem disablePadding>
                  <Tooltip title="Traces" placement="right">
                    <ListItemButton
                      sx={buttunSx}
                      component={NavLink}
                      to={`/traces`}
                    >
                      <IconButton sx={{ marginRight: "8px !important" }}>
                        <IconHttpTrace fontSize="small" />
                      </IconButton>
                      <ListItemText
                        primary="Traces"
                        sx={{ whiteSpace: "nowrap" }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}
            </div>
            <div
              id="Logs"
              aria-valuetext="Logs"
              onClick={changeSideBarHandler}
            >
              {keycloak?.authenticated && isPermitted &&(
                <ListItem disablePadding>
                  <Tooltip title="Logs" placement="right">
                    <ListItemButton
                      sx={buttunSx}
                      component={NavLink}
                      to={`/logs`}
                    >
                      <IconButton>
                        <DescriptionIcon fontSize="small" />
                      </IconButton>
                      <ListItemText
                        primary="Logs"
                        sx={{ whiteSpace: "nowrap" }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}
            </div>

            <div
              id="TMobile"
              aria-valuetext="TMobile"
              onClick={changeSideBarHandler}
            >
              {keycloak?.authenticated && isPermitted &&(
                <ListItem disablePadding>
                  <Tooltip title="TMobile" placement="right">
                    <ListItemButton
                      sx={buttunSx}
                      component={NavLink}
                      to={`/tmobile`}
                    >
                      <IconButton>
                        <DockIcon fontSize="small" />
                      </IconButton>
                      <ListItemText
                        primary="TMobile"
                        sx={{ whiteSpace: "nowrap" }}
                      />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}
            </div>

          </List>
        </nav>
      </aside>
    </Box>
  );
};

export default AppSidebar;
